import rozcestnikUdaje from '../../content/rozcestnik/rozcestnikUdaje.jsx';
import { initRozcestnikZememerictvi } from "./rozcestnikZememerictviService.js";
import { initRozcestnik } from "./rozcestnikService.js";
import { destroyElement } from "../../utils/common.mjs";

export function initRozcestnikUdaje(isPublic) {

    const tilesDiv = document.getElementById('tiles');
    tilesDiv.innerHTML = "";
    
    tilesDiv.appendChild(rozcestnikUdaje(isPublic));
    tilesDiv.style.display = 'block';
    
    const divFormio = document.querySelector('#divFormio');
    divFormio.style.display = "none";
    destroyElement('back-button-services');

    const home = document.getElementById('rozcestnikRoot');
    home.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnik(isPublic);
    });

    const zememerictviTile = document.getElementById('zememerictviTile');
    zememerictviTile.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikZememerictvi(isPublic);
    });

    const sszLinkTile = document.getElementById("ssz-link-tile");

    if (!isPublic && sszLinkTile) {
      fetch("/ssz")
        .then((response) => response.text())
        .then((data) => {
            if (data.length > 0) {
              sszLinkTile.setAttribute(
                "href",
                data === "Ano" ? "/SszLogin" : "/SszZrizeni"
              );
            }
        });
    }
}